import { reachMetrikaGoal } from '../variables';
const purchasingForm = () => {
    const form = document.querySelector('#oneStepForm');
    if (!form)
        return;
    // TST-028: CHECKOUT_START — первый ввод в любое поле формы заказа, один раз за просмотр
    form.addEventListener('input', () => reachMetrikaGoal('CHECKOUT_START'), { once: true });
    const paymentMethods = form.querySelectorAll('input[name="payment-id"]');
    const legalEntityFields = form.querySelector('#legal-entity-fields');
    const individualFields = form.querySelector('#individual-fields');
    const additionalInfoFields = form.querySelector('#additional-info-fields');
    const parts = document.querySelectorAll('.cart__product__wrapper[data-parts="1"]');
    if (!legalEntityFields || !individualFields || !additionalInfoFields)
        return;
    const toggleFields = (isLegal) => {
        legalEntityFields.classList.toggle('hide', !isLegal);
        individualFields.classList.toggle('hide', isLegal);
    };
    legalEntityFields.classList.add('hide');
    individualFields.classList.add('hide');
    additionalInfoFields.classList.toggle('hide', parts.length === 0);
    paymentMethods.forEach((input) => {
        input.addEventListener('change', () => {
            console.log(input.id);
            toggleFields(input.id === '4459');
        });
    });
};
export default purchasingForm;
